import { Button } from '../../atoms/Button';
import Checkbox from '../../atoms/Checkbox';
import { Typography } from '../../molecules/Typography';
import { Modal } from '../../templates/Modal';

interface IRedirectModal {
  isOpen: boolean;
  onClose: () => void;
  onCheck?: () => void;
  redirect: string;
  checked?: boolean;
  showCheckbox?: boolean;
  openOnNewTab?: boolean;
}

export default function RedirectModel({
  isOpen,
  onClose,
  onCheck,
  redirect,
  checked = false,
  showCheckbox = true,
  openOnNewTab = false,
}: IRedirectModal) {
  return (
    <Modal
      position='center'
      size='md'
      isOpen={isOpen}
      onClose={() => onClose()}
    >
      <div className='flex flex-col gap-xl p-1'>
        <div className='flex flex-col gap-[10px]'>
          <Typography>Caro aluno(a),</Typography>
          <Typography>
            gostariamos de informar que{' '}
            <b>esta funcionalidade ainda não passou pelo nosso redesign</b>, mas
            não se preocupe! Estamos trabalhando duro para que muito em breve
            você possa ter a experiência completa da nova plataforma do Aprova.
          </Typography>
          <Typography weight='bold'>
            Por enquanto, ao acessar essa funcionalidade, vamos redirecioná-lo
            para a plataforma antiga.
          </Typography>
          <Typography>
            Agradecemos pela compreensão e paciência. Se precisarem de ajuda,
            estamos à disposição!
          </Typography>
          <Typography>Atenciosamente,</Typography>
          <Typography>Equipe Aprova total🚀 💙</Typography>
        </div>
        {showCheckbox && onCheck && (
          <div>
            <Checkbox
              onChange={() => onCheck()}
              label='Não mostrar essa mensagem novamente ao acessar essa funcionalidade'
              checked={checked}
              id='show-no-more'
              value='show-no-more'
              variant='rounded'
            />
          </div>
        )}
        <div className='flex flex-row gap-sm items-center justify-end'>
          <Button allowReadOnly variant='text' onClick={() => onClose()}>
            Fechar
          </Button>
          <Button
            onClick={() => {
              if (openOnNewTab) {
                window.open(redirect, '_blank');
                onClose();
                return;
              }

              window.open(redirect, '_self');
            }}
          >
            Acessar na plataforma antiga
          </Button>
        </div>
      </div>
    </Modal>
  );
}
